import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgResumeLockIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="resume_lock_svg__nc-icon-wrapper">
      <path
        data-color="color-2"
        d="M47 40c0-2.757 2.243-5 5-5s5 2.243 5 5v5h2v-5c0-3.86-3.14-7-7-7s-7 3.14-7 7v5h2v-5z"
      />
      <path d="M28 33c8.585 0 15-8.975 15-17 0-8.271-6.729-15-15-15S13 7.729 13 16c0 8.025 6.415 17 15 17z" />
      <path
        data-color="color-2"
        d="M62 47H42a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V48a1 1 0 0 0-1-1zM52 57a2 2 0 1 1-.001-3.999A2 2 0 0 1 52 57z"
      />
      <path d="M39 48c0-1.654 1.346-3 3-3h1v-4.399C39.035 39.678 34.068 39 28 39c-11.118 0-18.567 2.269-22.858 4.173A6.988 6.988 0 0 0 1 49.567V60a1 1 0 0 0 1 1h37V48z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgResumeLockStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgResumeLockIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const ResumeLockIcon: any = SvgResumeLockStyle;
export default ResumeLockIcon;
